import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ComplaintsService} from '../services/complaints.service';
import {FormsModule} from '@angular/forms';
import {ResultsListComponent} from '@shared/results-list/results-list.component';
import {GenericSearchBarComponent} from '@shared/generic-search-bar/generic-search-bar.component';

@Component({
  selector: 'app-complaints-list',
  templateUrl: './complaints-list.component.html',
  styleUrls: ['./complaints-list.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ResultsListComponent,
    GenericSearchBarComponent
  ]
})
export class ComplaintsListComponent implements OnInit {
  searchObj: any = {};
  display_fields = ['site_name', 'investigation_assignments', 'incident_type', 'alleged_violation', 'received_datetime', 'received_by'];
  filterFields = ['incident_type', 'alleged_violation', 'received_by', 'is_duplicate'];

  constructor(
    public route: ActivatedRoute,
    public router: Router,
    public complaintsService: ComplaintsService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.searchObj = {
        search: params['search'] || '',
        page: params['page'] || 1,
        ordering: params['ordering'] || '-created_date'
      };
      // Pass through any filter field params into searchObj
      this.filterFields.forEach(f => {
        if (params[f]) {
          this.searchObj[f] = params[f];
        }
      });
    });
  }

  onSearchObjChange(updated: any): void {
    this.searchObj = updated;
    const queryParams: any = {search: updated.search, page: updated.page};
    this.filterFields.forEach(f => {
      queryParams[f] = updated[f] ?? null;
    });
    this.router.navigate([], {queryParams, queryParamsHandling: 'merge'});
  }
}
